import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

export const useDebug = () => {
  const [debugData, setDebugData] = useState<any>(null)

  return {
    debugData,
    setDebugData,
  }
}

const Wrapper = styled.div`
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`

export const Debug = ({
  object = {},
  useFormValues,
}: {
  object?: any
  useFormValues?: boolean
}) => {
  const methods = useFormContext()
  if (useFormValues && !!methods) {
    return <Wrapper>{JSON.stringify(methods.watch())}</Wrapper>
  }
  return <Wrapper>{JSON.stringify(object)}</Wrapper>
}
